export default __webpack_public_path__ + "static/media/BackArrow.9c2b0969.svg";